/** Plan Beta на карточке пациента (parity MIS PatientPlanWorkspace). */
import { useEffect, useState } from 'react'
import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import type { AuthSession } from '../../../../types/plans'
import { staffApi } from '../../../../api/staff'
import { usePatientVatechCtCatalog } from './usePatientVatechCtCatalog'
import { PlanDiagnosticsBetaPanel } from './PlanDiagnosticsBetaPanel'

export function PlanDiagnosticsBetaCardSection({
  bootstrap,
  session,
  lkPatientId,
  staffUserId,
  enabled = true,
  onApplied,
}: {
  bootstrap: TenantBootstrapModel
  session: AuthSession
  lkPatientId: number | null
  staffUserId: string
  enabled?: boolean
  onApplied?: () => void
}) {
  const [diagnosticsLinked, setDiagnosticsLinked] = useState(false)

  const catalogHook = usePatientVatechCtCatalog({
    bootstrap,
    session,
    lkPatientId,
    enabled: enabled && Boolean(lkPatientId),
  })

  const misPatientId = catalogHook.catalog?.mis_patient_id ?? null

  useEffect(() => {
    if (!enabled || !lkPatientId) {
      setDiagnosticsLinked(false)
      return
    }
    let cancelled = false
    void staffApi
      .getPatientDiagnocat(bootstrap, session, lkPatientId)
      .then((data) => {
        if (!cancelled) setDiagnosticsLinked(Boolean(data.linked) && data.status === 'linked')
      })
      .catch(() => {
        if (!cancelled) setDiagnosticsLinked(false)
      })
    return () => {
      cancelled = true
    }
  }, [bootstrap, session, lkPatientId, enabled])

  if (!enabled || !lkPatientId) return null

  return (
    <section className="grid gap-3 rounded-[28px] border border-violet-200/80 bg-violet-50/20 p-5 shadow-sm">
      <div>
        <h3 className="text-lg font-semibold text-slate-900">Plan Beta — из диагностики</h3>
        <p className="mt-1 text-sm text-slate-600">Составить план по findings Diagnocat без повторной отправки КТ.</p>
      </div>
      <PlanDiagnosticsBetaPanel
        bootstrap={bootstrap}
        session={session}
        misPatientId={misPatientId}
        staffUserId={staffUserId}
        diagnosticsLinked={diagnosticsLinked}
        onApplied={onApplied}
      />
    </section>
  )
}
